import Vue from 'vue'
import VuePageTitle from 'vue-page-title'
import App from './App.vue'
import router from './router'
import store from './store'
// import FirebaseAuthService from './services/firebase'
import { i18n } from '@/localization'
import VueLayers from 'vuelayers'
import BootstrapVue from 'bootstrap-vue'
import VueFab from 'vue-float-action-button'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import VueGtag from "vue-gtag";

// import Vuetify from 'vuetify'
import {
  TreeSelect, Rate, Breadcrumb, InputNumber, Steps, Message,
  Upload, Button, Layout, Table, Icon, Progress, Radio, Dropdown, Menu,
  Carousel, Input, Calendar, Badge, Slider, Form, FormModel, Tooltip, Select, Switch,
  Tag, Affix, Spin, Alert, Checkbox, Tabs, Pagination, notification, Drawer,
  Cascader, DatePicker, TimePicker, Divider, Anchor, AutoComplete, BackTop, Collapse, Card, List, Popover,
  Tree, Timeline, Row, Col, Transfer, Modal, message, Popconfirm, Skeleton, LocaleProvider, ConfigProvider, Descriptions, Statistic,
} from 'ant-design-vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import './global.scss'
import axios from './services/vue-axios/axios.js'
import VueAxios from 'vue-axios'
import UUID from 'vue-uuid'
import { Photoshop } from 'vue-color'
import VueGoodTablePlugin from 'vue-good-table'
import auditmixins from './mixins/auditmixins.js'
// import the styles
import 'vue-good-table/dist/vue-good-table.css'
import VueSvgGauge from 'vue-svg-gauge'
import Trend from 'vuetrend'
import DT from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import Avatar from 'vue-avatar'
import VueApexCharts from 'vue-apexcharts'
import JsonCSV from 'vue-json-csv'
import vSelect from 'vue-select'
import VueTagsInput from '@johmun/vue-tags-input'
import VueTour from 'vue-tour'
import Loading from 'vue-loading-overlay'
import vuetify from '@/plugins/vuetify' // path to vuetify export

import 'vue-loading-overlay/dist/vue-loading.css'

import 'vue-select/dist/vue-select.css'
import 'vuetify/dist/vuetify.min.css'
// Import FilePond styles
import 'filepond/dist/filepond.min.css'
import 'vue-tour/dist/vue-tour.css'

Vue.use(VueGtag, {
  config: { id: 'G-NHR53BJTM4' }
});

Vue.use(VueTour)
Vue.use(VueTagsInput)
Vue.use(Trend)
Vue.use(VueSvgGauge)
Vue.use(Loading)
Vue.use(VueGoodTablePlugin)
Vue.use(Photoshop)
Vue.use(VueFab)
Vue.use(UUID)
Vue.component('downloadCsv', JsonCSV)
Vue.component('v-select', vSelect)
Vue.use(VueAxios, axios)
// Vue.use(Vuetify)
Vue.use(BootstrapVue)

Vue.use(VueLayers)
Vue.use(ConfigProvider)
Vue.use(Skeleton)
// Vue.use(Avatar)
Vue.use(Popconfirm)
Vue.use(Transfer)
Vue.use(Modal)
Vue.use(Divider)
Vue.use(Row)
Vue.use(Col)
Vue.use(Timeline)
Vue.use(Tree)
Vue.use(Popover)
Vue.use(List)
Vue.use(Card)
Vue.use(Button)
Vue.use(Rate)
Vue.use(TreeSelect)
Vue.use(Breadcrumb)
Vue.use(Layout)
Vue.use(Table)
Vue.use(Icon)
Vue.use(Progress)
Vue.use(Radio)
Vue.use(Dropdown)
Vue.use(Menu)
Vue.use(Carousel)
Vue.use(Input)
Vue.use(Calendar)
Vue.use(Badge)
Vue.use(Slider)
Vue.use(Form)
Vue.use(FormModel)
Vue.use(Tooltip)
Vue.use(Select)
Vue.use(Tag)
Vue.use(Affix)
Vue.use(Spin)
Vue.use(Alert)
Vue.use(Checkbox)
Vue.use(Tabs)
Vue.use(Pagination)
Vue.use(Upload)
Vue.use(Message)
Vue.use(Steps)
Vue.use(InputNumber)
Vue.use(Drawer)
Vue.use(Switch)
Vue.use(Cascader)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Anchor)
Vue.use(AutoComplete)
Vue.use(Collapse)
Vue.use(BackTop)
Vue.use(LocaleProvider)
Vue.use(Descriptions)
Vue.use(Statistic)

Vue.prototype.$notification = notification
Vue.prototype.$message = message

// Vue.use(FirebaseAuthService)
Vue.use(axios)
Vue.use(VuePageTitle, {
  prefix: 'Ravenware | ',
  router,
})
Vue.use(VueMoment, {
  moment,
})
Vue.use(DT)
Vue.config.productionTip = false
Vue.component('avatar', Avatar)

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Vue.mixin(auditmixins)
// axios interceptors
const errorHandler = (error) => {
  if (error != null && error.response != null && error.response.status === 401) {
    router.push('/system/login')
    return Promise.reject(error)
  }
  // cancel progress on fail.
  return Promise.reject(error)
}
const successHandler = (response) => {
  // can log on success here.
  return response
}
axios.interceptors.response.use(
  response => successHandler(response),
  error => errorHandler(error)
)

axios.interceptors.request.use((config) => {
  // config.headers.genericKey = 'someGenericValue'
  if (localStorage.umbriltoken != null) { config.headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.umbriltoken } } else {
    config.headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' }
  }
  return config
}, (error) => {
  return Promise.reject(error)
})
// end axios interceptors
Vue.prototype.$eventHub = new Vue() // Global event bus
new Vue({
  vuetify,
  router,
  components: {
    PulseLoader,
  },
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
